<template>
  <Layout :class="{whiteBook: activeType=== 2}">
    <!-- 去掉多余信息 -->
    <div slot="nav"></div>
    <div slot="sub-nav"></div>
    <div class="list-content container">
      <div class="nav-wrapper">
        <div class="nav-bar">
          <h2>跳转到类别</h2>
          <ul>
            <li v-for="(item, i) in typeList" :key="i" class="type-item"
            :class="{'active-type': Number(activeType) === i}"
            @click="changeType(i)" v-html="item.name"></li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="banner">
          <h2 v-html="itemInfo.title.mainTitle"></h2>
          <span>{{itemInfo.title.subTitle}}</span>
        </div>
        <div class="list-wrapper">
          <template v-if="params === 0">
            <div class="item-wrapper">
              <com-card2 class="message-item" :card-info="msgItem" v-for="(msgItem, msgIndex) in data[typeList[params].router]['list']" :key="msgItem + '-' + msgIndex" />
            </div>
          </template>
          <template v-if="params === 1">
            <div class="item-wrapper">
              <com-card3 class="white-item" :card-info="paperItem" v-for="(paperItem, paperIndex) in data[typeList[params].router]['list']" :key="paperItem + '' + paperIndex" />
            </div>
          </template>
          <template v-if="params === 2">
            <div class="item-wrapper">
              <com-card1 class="guide-item" :card-info="guideItem" v-for="(guideItem, guideIndex) in data[typeList[params].router]['list']" :key="guideItem + '' + guideIndex" />
            </div>
          </template>
          <template v-if="params === 3">
            <div class="case-tab">
              <!-- <span :class="{active: activeTab === 0}" @click="activeTab = 0">视频案例</span> -->
              <!-- <span :class="{active: activeTab === 1}" @click="activeTab = 1">文章案例</span> -->
              <span :class="{active: activeTab === 0}" @click="activeTab = 0">文章案例</span>
            </div>
            <div class="item-wrapper">
              <!-- <div class="case-item-wrap" v-show="activeTab === 0">
                <com-card4 class="case-item" :card-info="caseItem1" v-for="(caseItem1, caseIndex1) in this.data['case']['listTop']" :key="caseItem1.link + '-' + caseIndex1" />
              </div>
              <div class="case-item-wrap" v-show="activeTab === 1">
                <com-card5 class="case-item" :card-info="caseItem2" v-for="(caseItem2, caseIndex2) in this.data['case']['listBottom']" :key="caseItem2.link + '-' + caseIndex2" />
              </div> -->
              <div class="case-item-wrap" v-show="activeTab === 0">
                <com-card5 class="case-item" :card-info="caseItem2" v-for="(caseItem2, caseIndex2) in this.data['case']['listBottom']" :key="caseItem2.link + '-' + caseIndex2" />
              </div>
            </div>
          </template>
          <template v-if="params === 4">
            <div class="item-wrapper">
              <LeftImgModule class="pso-item" :info="paperItem" v-for="(paperItem, paperIndex) in data[typeList[params].router]['content']" :key="paperItem + '' + paperIndex" ></LeftImgModule>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div slot="footer-service"></div>
  </Layout>
</template>
<script>
import Layout from 'components/layout/Layout'
import data from '@/data'

import ComCard1 from '@/components/card1'
import ComCard2 from '@/components/card2'
import ComCard3 from '@/components/card3'
// import ComCard4 from '@/components/card4'
import ComCard5 from '@/components/card5'
import LeftImgModule from '@/components/left-img.vue'

export default {
  components: {
    Layout,
    ComCard1,
    ComCard2,
    ComCard3,
    // ComCard4,
    ComCard5,
    LeftImgModule
  },
  data () {
    return {
      data: data,
      activeTab: 0,
      params: Number(this.$route.query.id) || 0,
      activeType: Number(this.$route.query.id) || 0
    }
  },
  watch: {
    '$route': {
      handler: function (val, oldVal) {
        this.params = val.query.id
      }
    }
  },
  computed: {
    typeList () {
      return [
        {
          name: this.data['message'].title.mainTitle,
          router: 'message'
        },
        {
          name: this.data['whitePaper'].title.mainTitle,
          router: 'whitePaper'
        },
        {
          name: this.data['guide'].title.mainTitle,
          router: 'guide'
        },
        {
          name: this.data['case'].title.mainTitle,
          router: 'case'
        },
        {
          name: this.data['pso'].title.mainTitle,
          router: 'pso'
        }
      ]
    },
    itemInfo () {
      return this.data[this.typeList[this.params].router] || 'guide'
    }
  },
  methods: {
    changeType (i) {
      this.activeType = i
      this.$router.push({ query: { id: i } })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/app.sass';
$default-blue: #1973E8;
/deep/ {
  .inner-content {
    background: #fff;
  }
}
.whiteBook /deep/ .inner-content {
  background: #F7F7F7;
}
.list-content {
  display: flex;
  box-sizing: border-box;
  padding: 40px 24px 0;
  .nav-wrapper {
    flex: none;
    .nav-bar {
      position: sticky; top: 60px;
      padding-top: 55px;
      padding-bottom: 48px;
      color: #202124; font-size: 16px;
      h2 {
        margin-bottom: 20px;
        font-weight: 500; line-height: 1;
      }
      ul {
        border-left: 2px solid #E0E3E6;
        li {
          margin-bottom: 30px;
          padding-left: 15px;
          font-weight: 400; line-height: 25px;
          cursor: pointer;
          &.active-type {
            position: relative;
            color: $default-blue; font-weight: 500;
            &::before {
              content: '';
              position: absolute; left: -2px; top: 0;
              width: 2px; height: 100%;
              background: $default-blue;
            }
          }
        }
      }
    }
  }
  @include mobile {
    padding: 40px 0 0;
    .nav-wrapper {
      display: none;
    }
  }
  .main {
    flex: none;
    padding-bottom: 50px;
    margin-left: auto;
    width: 972px;
    .banner {
      box-sizing: border-box;
      padding: 55px 0 55px 50px;
      margin-bottom: 40px;
      background-color: $default-blue;
      background-image: url('../../assets/img/google-img/bannerBg.png');
      background-size: contain;
      background-position: 95% top;
      background-repeat: no-repeat;
      border-radius: 3px;
      color: #fff;
      h2 {
        margin-bottom: 20px;
        font-size: 36px; font-weight: 500; line-height: 1;
      }
      span {
        font-size: 20px; font-weight: 400; line-height: 1;
      }
    }
    @include mobile {
      width: 100%;
      .banner {
        padding: 30px 20px;
        min-height: 166px;
        background-size: 80%;
        background-position: right top;
        h2 {
          font-size: 26px;
        }
        span {
          font-size: 16px;
        }
      }
    }
  }
  .list-wrapper {
    .item-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      & /deep/ {
        .guide-item,
        .white-item,
        .case-item,
        .pso-item {
          margin-bottom: 30px;
          width: 470px;
          @include mobile {
            width: 100%;
          }
        }
        .message-item {
          margin-bottom: 30px;
          width: 100%; height: 155px;
          & .image {
            width: 252px;
          }
          & .content {
            position: relative;
            &::after {
              content: '';
              position: absolute; bottom: -14px; left: 0;
              width: 100%; height: 1px;
              background: rgba(32, 33, 36, .1);
            }
          }
          &:last-child {
            & .content::after {
              height: 0;
            }
          }
          @include mobile {
            padding-top: 10px;
            margin-bottom: 0px;
            height: auto;
            & .image {
              width: 100%;
            }
          }
        }
        // .pso-item {
        //   border: none;
        // }
      }
    }
    .case-tab {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 17px;
      padding-right: 20px;
      margin-bottom: 35px;
      border-bottom: 1px solid rgba(32, 33, 36, .1);
      font-size: 20px; font-weight: 500; line-height: 1;
      span {
        display: block;
        margin-left: 35px;
        cursor: pointer;
      }
      span.active {
        position: relative;
        color: $default-blue;
        &:after {
          content: '';
          position: absolute; bottom: -17px; left: -10%;
          width: 120%; height: 2px;
          background: $default-blue;
        }
      }
    }
    .case-item-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
}
</style>
